export const FIRM = {
  name: "Legalia Società tra Avvocati",
  shortName: "Legalia",
  wordmark: "Legalia",
  tagline: "Società tra Avvocati",
  city: "Manduria",
  address: "Piazza Vittorio Emanuele II, 20/c · 74024 Manduria (TA)",
  phone: "099 971 1448",
  phoneHref: "+390999711448",
  whatsapp: "392 359 8141",
  whatsappHref: "https://wa.me/3923598141",
  pec: "legalia@pec.it",
  email: "studiobdlex@gmail.com",
  hours: "Lun – Ven · 9:00 – 19:00 · Su appuntamento",
};

export const PRACTICE_AREAS = [
  "Diritto Civile e Familiare",
  "Diritto Penale",
  "Diritto Societario e M&A",
  "Diritto Immobiliare",
  "Recupero Crediti ed Esecuzioni",
  "Protezione Patrimoniale",
  "Altro",
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -116, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
